import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';
import { actions as CanvasActions } from '~app/features/canvas';

const ClickOrEnterDiv = withEnterToClick('div');

const ToggleHints = () => {
  const t = useT();
  const showHints = useSelector(state => state.canvas?.showHints);
  const showHintToggler = useSelector(
    state => state.canvas?.hintsAreApplicable,
  );

  const hintTogglerLabel = showHints ? 'turn-hints-off' : 'turn-hints-on';
  const dispatch = useDispatch();
  const toggleHints = useCallback(() => {
    if (showHints) {
      dispatch(CanvasActions.hideHints());
    } else {
      dispatch(CanvasActions.revealHints());
    }
  }, [dispatch, showHints]);

  return showHintToggler ? (
    <ClickOrEnterDiv
      className={`ToggleHints__button`}
      role="button"
      tabIndex="0"
      aria-label={t(hintTogglerLabel)}
      onClick={toggleHints}
    >
      {t(hintTogglerLabel)}
    </ClickOrEnterDiv>
  ) : null;
};

export default ToggleHints;
